import { useEffect, useState } from 'react';
import { getMetabaseDashboardUrl } from '@gtintel/platform-api';
export function MetabaseIframe({
  dashboardId
}) {
  const [iframeUrl, setIframeUrl] = useState('');
  useEffect(() => {
    getMetabaseDashboardUrl(dashboardId).then(url => {
      if (url.metabase_iframe) {
        setIframeUrl(url.metabase_iframe);
      }
    });
  }, [dashboardId]);
  return <iframe src={iframeUrl} width="100%" height="100%" frameBorder="0" title="Metabase Dashboard" />;
}
export default MetabaseIframe;